module.exports = __webpack_public_path__ + "static/0004-8c26e3b9ec616491b217d58e08d9693d.png";